"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.capitalizeFirstLetter = void 0;
/**
 * Convert the first character of each word to uppercase.
 */
const capitalizeFirstLetter = (str) => str.replace(/\b\w/g, char => char.toUpperCase());
exports.capitalizeFirstLetter = capitalizeFirstLetter;
//# sourceMappingURL=string.js.map